import { useState } from "react";
import PropTypes from "prop-types";
import AccordionItem from "./AccordionItem";
const Accordion = ({ accordionItems }) => {
  const [openId, setOpenId] = useState(null);

  const handleToggle = (id) => {
    setOpenId((currentId) => (currentId === id ? null : id));
  };
  return (
    <>
      {accordionItems?.map((item, index) => (
        <AccordionItem
          key={index}
          item={item}
          isOpen={openId === index }
          onToggle={() => handleToggle(index)}
        />
      ))}
    </>
  );
};

Accordion.propTypes = {
  accordionItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
      content: PropTypes.string,
    }),
  ),
};

export default Accordion;
